// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import __setDefaultSdkOptions from "../sdk-helpers/__setDefaultSdkOptions";

import createAwardCustomArchive from "./award/postAwardCustomArchive";
import createAwardCustomCreate from "./award/postAwardCustomCreate";
import createAwardCustomDelete from "./award/postAwardCustomDelete";
import createAwardCustomGive from "./award/postAwardCustomGive";
import createAwardCustomList from "./award/postAwardCustomList";
import createAwardCustomRestore from "./award/postAwardCustomRestore";
import createAwardCustomTakeBack from "./award/postAwardCustomTakeBack";
import createAwardCustomUpdate from "./award/postAwardCustomUpdate";
import createAwardGetForAccount from "./award/postAwardGetForAccount";
import createAwardGetForMember from "./award/postAwardGetForMember";
import createAwardGetMine from "./award/postAwardGetMine";
import createContestCancel from "./contest/postContestCancel";
import createContestConfirm from "./contest/postContestConfirm";
import createContestCorrectionReviewGet from "./contest/postContestCorrectionReviewGet";
import createContestCorrectionReviewResolve from "./contest/postContestCorrectionReviewResolve";
import createContestCreate from "./contest/postContestCreate";
import createContestDelete from "./contest/postContestDelete";
import createContestGet from "./contest/postContestGet";
import createContestList from "./contest/postContestList";
import createContestMakeupReviewGet from "./contest/postContestMakeupReviewGet";
import createContestMakeupWaive from "./contest/postContestMakeupWaive";
import createContestPendingOutcomeGet from "./contest/postContestPendingOutcomeGet";
import createContestPendingSetupGet from "./contest/postContestPendingSetupGet";
import createContestPendingSetupSave from "./contest/postContestPendingSetupSave";
import createContestReopen from "./contest/postContestReopen";
import createContestReopenPreviewGet from "./contest/postContestReopenPreviewGet";
import createContestReopenResolve from "./contest/postContestReopenResolve";
import createContestRulesGet from "./contest/postContestRulesGet";
import createContestSetupGet from "./contest/postContestSetupGet";
import createContestSetupSave from "./contest/postContestSetupSave";
import createContestTiebreakSet from "./contest/postContestTiebreakSet";
import createContestUpdate from "./contest/postContestUpdate";
import createContestValidateConfig from "./contest/postContestValidateConfig";
import createEntryCreate from "./entry/postEntryCreate";
import createEntryGet from "./entry/postEntryGet";
import createEntryListForMember from "./entry/postEntryListForMember";
import createEntryListMine from "./entry/postEntryListMine";
import createEntryRevive from "./entry/postEntryRevive";
import createPickChange from "./pick/postPickChange";
import createPickRemove from "./pick/postPickRemove";
import createPickReorder from "./pick/postPickReorder";
import createPickSkipRound from "./pick/postPickSkipRound";
import createPickSubmit from "./pick/postPickSubmit";
import createPickUndoSkip from "./pick/postPickUndoSkip";
import createPickemContestCreate from "./pickem/postPickemContestCreate";
import createPickemMissingPicksList from "./pickem/postPickemMissingPicksList";
import createPickemNudge from "./pickem/postPickemNudge";
import createPickemPicksSubmit from "./pickem/postPickemPicksSubmit";
import createPickemPoolGet from "./pickem/postPickemPoolGet";
import createPickemResultsGet from "./pickem/postPickemResultsGet";
import createPickemRoundGet from "./pickem/postPickemRoundGet";
import createPickemSettingsUpdate from "./pickem/postPickemSettingsUpdate";
import createPickemSetupPreview from "./pickem/postPickemSetupPreview";
import createPickemStandingsGet from "./pickem/postPickemStandingsGet";
import createResultsGetByMember from "./results/postResultsGetByMember";
import createResultsGetByRound from "./results/postResultsGetByRound";
import createRoundGetBoard from "./round/postRoundGetBoard";
import createRoundList from "./round/postRoundList";
import createRoundNudgeEntry from "./round/postRoundNudgeEntry";
import createRoundUnpickedList from "./round/postRoundUnpickedList";
import createSeasonLeaderboardGet from "./season/postSeasonLeaderboardGet";
import createSeasonList from "./season/postSeasonList";
import createSeasonStart from "./season/postSeasonStart";
import createSeasonStartOptions from "./season/postSeasonStartOptions";
import createSquaresAssigneeList from "./squares/postSquaresAssigneeList";
import createSquaresCustomGridAdd from "./squares/postSquaresCustomGridAdd";
import createSquaresCustomGridRename from "./squares/postSquaresCustomGridRename";
import createSquaresGridAdd from "./squares/postSquaresGridAdd";
import createSquaresGridClear from "./squares/postSquaresGridClear";
import createSquaresGridCopyFrom from "./squares/postSquaresGridCopyFrom";
import createSquaresGridGet from "./squares/postSquaresGridGet";
import createSquaresGridLock from "./squares/postSquaresGridLock";
import createSquaresGridPublish from "./squares/postSquaresGridPublish";
import createSquaresGridRandomize from "./squares/postSquaresGridRandomize";
import createSquaresGridUnlock from "./squares/postSquaresGridUnlock";
import createSquaresGridUnpublish from "./squares/postSquaresGridUnpublish";
import createSquaresGuestCreate from "./squares/postSquaresGuestCreate";
import createSquaresGuestList from "./squares/postSquaresGuestList";
import createSquaresGuestRemove from "./squares/postSquaresGuestRemove";
import createSquaresGuestUpdate from "./squares/postSquaresGuestUpdate";
import createSquaresPoolGet from "./squares/postSquaresPoolGet";
import createSquaresPresetsGet from "./squares/postSquaresPresetsGet";
import createSquaresPreviewGames from "./squares/postSquaresPreviewGames";
import createSquaresResultsGet from "./squares/postSquaresResultsGet";
import createSquaresRulesGet from "./squares/postSquaresRulesGet";
import createSquaresSeasonStart from "./squares/postSquaresSeasonStart";
import createSquaresSeasonStartPreview from "./squares/postSquaresSeasonStartPreview";
import createSquaresSeasonUpdate from "./squares/postSquaresSeasonUpdate";
import createSquaresSquareAssign from "./squares/postSquaresSquareAssign";
import createSquaresSquareRelease from "./squares/postSquaresSquareRelease";
import createSquaresSquareTake from "./squares/postSquaresSquareTake";
import createSquaresWinnerAdd from "./squares/postSquaresWinnerAdd";
import createSquaresWinnerRemove from "./squares/postSquaresWinnerRemove";
import createStandingsGet from "./standings/postStandingsGet";
import createStripsAssigneeList from "./strips/postStripsAssigneeList";
import createStripsCardGet from "./strips/postStripsCardGet";
import createStripsCustomGameAdd from "./strips/postStripsCustomGameAdd";
import createStripsCustomGameRename from "./strips/postStripsCustomGameRename";
import createStripsGameAdd from "./strips/postStripsGameAdd";
import createStripsGameRemove from "./strips/postStripsGameRemove";
import createStripsPoolGet from "./strips/postStripsPoolGet";
import createStripsResultsGet from "./strips/postStripsResultsGet";
import createStripsSettingsUpdate from "./strips/postStripsSettingsUpdate";
import createStripsSpotAssign from "./strips/postStripsSpotAssign";
import createStripsSpotClaim from "./strips/postStripsSpotClaim";
import createStripsSpotRelease from "./strips/postStripsSpotRelease";
import createStripsStripAdd from "./strips/postStripsStripAdd";
import createStripsStripCopyUsers from "./strips/postStripsStripCopyUsers";
import createStripsStripLock from "./strips/postStripsStripLock";
import createStripsStripUnlock from "./strips/postStripsStripUnlock";
import createStripsWinnerUpdate from "./strips/postStripsWinnerUpdate";
import createStripsWinnersSet from "./strips/postStripsWinnersSet";
import createTrophyAssign from "./trophy/postTrophyAssign";
import createTrophyUnassign from "./trophy/postTrophyUnassign";

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

// Every method is built from RESOLVED options, never the raw argument.
// `sdk()` with no arguments has to work. That is the shape every generated
// hook uses through useCallSdk(), and passing the raw `undefined` through
// gave those methods no apiHost and no "/v1/<zone>" prefix, so they POSTed to
// a bare relative "/resource/action".
export default function sdk(options?: SdkOptions) {
  const resolvedOptions = __setDefaultSdkOptions(options);
  return {
    postAwardCustomArchive: createAwardCustomArchive(resolvedOptions),
    postAwardCustomCreate: createAwardCustomCreate(resolvedOptions),
    postAwardCustomDelete: createAwardCustomDelete(resolvedOptions),
    postAwardCustomGive: createAwardCustomGive(resolvedOptions),
    postAwardCustomList: createAwardCustomList(resolvedOptions),
    postAwardCustomRestore: createAwardCustomRestore(resolvedOptions),
    postAwardCustomTakeBack: createAwardCustomTakeBack(resolvedOptions),
    postAwardCustomUpdate: createAwardCustomUpdate(resolvedOptions),
    postAwardGetForAccount: createAwardGetForAccount(resolvedOptions),
    postAwardGetForMember: createAwardGetForMember(resolvedOptions),
    postAwardGetMine: createAwardGetMine(resolvedOptions),
    postContestCancel: createContestCancel(resolvedOptions),
    postContestConfirm: createContestConfirm(resolvedOptions),
    postContestCorrectionReviewGet:
      createContestCorrectionReviewGet(resolvedOptions),
    postContestCorrectionReviewResolve:
      createContestCorrectionReviewResolve(resolvedOptions),
    postContestCreate: createContestCreate(resolvedOptions),
    postContestDelete: createContestDelete(resolvedOptions),
    postContestGet: createContestGet(resolvedOptions),
    postContestList: createContestList(resolvedOptions),
    postContestMakeupReviewGet: createContestMakeupReviewGet(resolvedOptions),
    postContestMakeupWaive: createContestMakeupWaive(resolvedOptions),
    postContestPendingOutcomeGet:
      createContestPendingOutcomeGet(resolvedOptions),
    postContestPendingSetupGet: createContestPendingSetupGet(resolvedOptions),
    postContestPendingSetupSave: createContestPendingSetupSave(resolvedOptions),
    postContestReopen: createContestReopen(resolvedOptions),
    postContestReopenPreviewGet: createContestReopenPreviewGet(resolvedOptions),
    postContestReopenResolve: createContestReopenResolve(resolvedOptions),
    postContestRulesGet: createContestRulesGet(resolvedOptions),
    postContestSetupGet: createContestSetupGet(resolvedOptions),
    postContestSetupSave: createContestSetupSave(resolvedOptions),
    postContestTiebreakSet: createContestTiebreakSet(resolvedOptions),
    postContestUpdate: createContestUpdate(resolvedOptions),
    postContestValidateConfig: createContestValidateConfig(resolvedOptions),
    postEntryCreate: createEntryCreate(resolvedOptions),
    postEntryGet: createEntryGet(resolvedOptions),
    postEntryListForMember: createEntryListForMember(resolvedOptions),
    postEntryListMine: createEntryListMine(resolvedOptions),
    postEntryRevive: createEntryRevive(resolvedOptions),
    postPickChange: createPickChange(resolvedOptions),
    postPickRemove: createPickRemove(resolvedOptions),
    postPickReorder: createPickReorder(resolvedOptions),
    postPickSkipRound: createPickSkipRound(resolvedOptions),
    postPickSubmit: createPickSubmit(resolvedOptions),
    postPickUndoSkip: createPickUndoSkip(resolvedOptions),
    postPickemContestCreate: createPickemContestCreate(resolvedOptions),
    postPickemMissingPicksList: createPickemMissingPicksList(resolvedOptions),
    postPickemNudge: createPickemNudge(resolvedOptions),
    postPickemPicksSubmit: createPickemPicksSubmit(resolvedOptions),
    postPickemPoolGet: createPickemPoolGet(resolvedOptions),
    postPickemResultsGet: createPickemResultsGet(resolvedOptions),
    postPickemRoundGet: createPickemRoundGet(resolvedOptions),
    postPickemSettingsUpdate: createPickemSettingsUpdate(resolvedOptions),
    postPickemSetupPreview: createPickemSetupPreview(resolvedOptions),
    postPickemStandingsGet: createPickemStandingsGet(resolvedOptions),
    postResultsGetByMember: createResultsGetByMember(resolvedOptions),
    postResultsGetByRound: createResultsGetByRound(resolvedOptions),
    postRoundGetBoard: createRoundGetBoard(resolvedOptions),
    postRoundList: createRoundList(resolvedOptions),
    postRoundNudgeEntry: createRoundNudgeEntry(resolvedOptions),
    postRoundUnpickedList: createRoundUnpickedList(resolvedOptions),
    postSeasonLeaderboardGet: createSeasonLeaderboardGet(resolvedOptions),
    postSeasonList: createSeasonList(resolvedOptions),
    postSeasonStart: createSeasonStart(resolvedOptions),
    postSeasonStartOptions: createSeasonStartOptions(resolvedOptions),
    postSquaresAssigneeList: createSquaresAssigneeList(resolvedOptions),
    postSquaresCustomGridAdd: createSquaresCustomGridAdd(resolvedOptions),
    postSquaresCustomGridRename: createSquaresCustomGridRename(resolvedOptions),
    postSquaresGridAdd: createSquaresGridAdd(resolvedOptions),
    postSquaresGridClear: createSquaresGridClear(resolvedOptions),
    postSquaresGridCopyFrom: createSquaresGridCopyFrom(resolvedOptions),
    postSquaresGridGet: createSquaresGridGet(resolvedOptions),
    postSquaresGridLock: createSquaresGridLock(resolvedOptions),
    postSquaresGridPublish: createSquaresGridPublish(resolvedOptions),
    postSquaresGridRandomize: createSquaresGridRandomize(resolvedOptions),
    postSquaresGridUnlock: createSquaresGridUnlock(resolvedOptions),
    postSquaresGridUnpublish: createSquaresGridUnpublish(resolvedOptions),
    postSquaresGuestCreate: createSquaresGuestCreate(resolvedOptions),
    postSquaresGuestList: createSquaresGuestList(resolvedOptions),
    postSquaresGuestRemove: createSquaresGuestRemove(resolvedOptions),
    postSquaresGuestUpdate: createSquaresGuestUpdate(resolvedOptions),
    postSquaresPoolGet: createSquaresPoolGet(resolvedOptions),
    postSquaresPresetsGet: createSquaresPresetsGet(resolvedOptions),
    postSquaresPreviewGames: createSquaresPreviewGames(resolvedOptions),
    postSquaresResultsGet: createSquaresResultsGet(resolvedOptions),
    postSquaresRulesGet: createSquaresRulesGet(resolvedOptions),
    postSquaresSeasonStart: createSquaresSeasonStart(resolvedOptions),
    postSquaresSeasonStartPreview:
      createSquaresSeasonStartPreview(resolvedOptions),
    postSquaresSeasonUpdate: createSquaresSeasonUpdate(resolvedOptions),
    postSquaresSquareAssign: createSquaresSquareAssign(resolvedOptions),
    postSquaresSquareRelease: createSquaresSquareRelease(resolvedOptions),
    postSquaresSquareTake: createSquaresSquareTake(resolvedOptions),
    postSquaresWinnerAdd: createSquaresWinnerAdd(resolvedOptions),
    postSquaresWinnerRemove: createSquaresWinnerRemove(resolvedOptions),
    postStandingsGet: createStandingsGet(resolvedOptions),
    postStripsAssigneeList: createStripsAssigneeList(resolvedOptions),
    postStripsCardGet: createStripsCardGet(resolvedOptions),
    postStripsCustomGameAdd: createStripsCustomGameAdd(resolvedOptions),
    postStripsCustomGameRename: createStripsCustomGameRename(resolvedOptions),
    postStripsGameAdd: createStripsGameAdd(resolvedOptions),
    postStripsGameRemove: createStripsGameRemove(resolvedOptions),
    postStripsPoolGet: createStripsPoolGet(resolvedOptions),
    postStripsResultsGet: createStripsResultsGet(resolvedOptions),
    postStripsSettingsUpdate: createStripsSettingsUpdate(resolvedOptions),
    postStripsSpotAssign: createStripsSpotAssign(resolvedOptions),
    postStripsSpotClaim: createStripsSpotClaim(resolvedOptions),
    postStripsSpotRelease: createStripsSpotRelease(resolvedOptions),
    postStripsStripAdd: createStripsStripAdd(resolvedOptions),
    postStripsStripCopyUsers: createStripsStripCopyUsers(resolvedOptions),
    postStripsStripLock: createStripsStripLock(resolvedOptions),
    postStripsStripUnlock: createStripsStripUnlock(resolvedOptions),
    postStripsWinnerUpdate: createStripsWinnerUpdate(resolvedOptions),
    postStripsWinnersSet: createStripsWinnersSet(resolvedOptions),
    postTrophyAssign: createTrophyAssign(resolvedOptions),
    postTrophyUnassign: createTrophyUnassign(resolvedOptions),
  };
}
